import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { userService } from 'services';
import { userAdacter } from 'adapters';
import useErrors from 'hooks/useErrors';
import { toast } from 'react-toastify';
import { contextApp } from 'context';

const useUser = (id = false) => {
 const { auth, setAuth, configDispatch } = contextApp();

 const [isLoading, setIsLoading] = useState(false);
 const { setError } = useErrors();

 const { updateUser, getUser } = userService.useApiUser();
 const queryClient = useQueryClient();

 const { mutate: mutateUpdate } = useMutation(updateUser);

 const { data } = useQuery(['userData'], () => getUser(id), {
  onError: err => setError(err),
  onSettled: () => console.log('termino la solicitud')
 });

 const onSubmitData = async newData => {
  setIsLoading(true);
  const dataSend = await userAdacter.update(newData);
  console.log(dataSend, 'datos preparados antes de enviar');
  mutateUpdate(dataSend, {
   onError: err => setError(err),
   onSettled: () => setIsLoading(false),
   onSuccess: obj => {
    console.log(obj, 'respuesta del servidor');
    if (obj?.message) return toast.error(obj?.message);
    queryClient.invalidateQueries(['userData']);
    setAuth({ ...auth, ...obj });
    localStorage.setItem('sesion', JSON.stringify({ ...auth, ...obj }));
    toast.success('Datos actualizados correctamente');
   }
  });
 };

 const onError = err => {
  console.log('se produjo un error ', err);
  //if (!validation) clearErrors();
 };

 return { isLoading, data, onError, onSubmitData, auth, configDispatch };
};

export default useUser;
